<template>
	<v-container>
		<v-row dense>
			<v-col
				v-for="notification in notifications"
				:key="notification.id"
				lg="3"
				md="4"
				sm="6"
				cols="12"
			>
				<v-list-item
					class="elevation-2 rounded"
					@click="markAsRead(notification)"
				>
					<v-list-item-avatar class="me-3">
						<v-avatar size="38" color="primary lighten-5">
							{{moment(notification.date).format('ddd')}}
						</v-avatar>
					</v-list-item-avatar>
					<v-list-item-content>
						<v-list-item-title class="text-body-2 font-weight-medium text-wrap">
							{{getNotificationTitle(notification)}}
						</v-list-item-title>
						<v-list-item-subtitle class="text-caption grey--text">
							{{$T('click-to-view-the-new-plan')}}
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-col>
		</v-row>

		<div
			v-if="!notifications.length"
			class="d-flex flex-column justify-center align-center"
			style="height: 65vh"
		>
			<v-icon x-large class="mb-3">mdi-bell-ring</v-icon>
			<span class="grey--text text--darken-2">{{$T('no-notifications')}}</span>
		</div>
	</v-container>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex'
export default {
	name: 'Notifications',
	
	computed: {
		...mapState({
			notifications: state => state.notifications.notifications
		})
	},

	methods: {
		getNotificationTitle(notification) {
			let translateKey, newVal, date, entity;
			if (notification.oldDate) {
				translateKey = 'visit-$-date-for-$-entity-changed-to-$';
				date = moment(notification.oldDate).format('dddd YYYY-MM-DD');
				entity = notification.entityName;
				newVal = moment(notification.date).format('dddd YYYY-MM-DD');
			} else if (notification.oldEntityName) {
				translateKey = 'visit-$-entity-for-$-date-changed-to-$';
				date = moment(notification.date).format('dddd YYYY-MM-DD');
				entity = notification.oldEntityName;
				newVal = notification.entityName;
			}
			
			const title = this.$T(translateKey, {
				date: date,
				entity: entity,
				newVal: newVal
			});
			return title;
		},

		markAsRead(notification) {
			this.$store.dispatch('notifications/markAsRead', {
				notificationId: notification.id
			}).then(() => {
				this.$store.dispatch('notifications/fetchAll', {
					fromDate: moment().format('YYYY-MM-DD'),
					toDate: moment().add(1, 'month').endOf('month').format('YYYY-MM-DD'),
				});
			});
			this.$router.push({
				name: 'plans',
				query: {
					date: moment(notification.date).format('YYYY-MM-DD')
				}
			})
		},
		
		moment
	}
}
</script>

<style>

</style>